import { render, staticRenderFns } from "./calendarDayEvent.vue?vue&type=template&id=65d632d0&scoped=true&"
import script from "./calendarDayEvent.vue?vue&type=script&lang=js&"
export * from "./calendarDayEvent.vue?vue&type=script&lang=js&"
import style0 from "./calendarDayEvent.vue?vue&type=style&index=0&id=65d632d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d632d0",
  null
  
)

export default component.exports